export default "__VITE_ASSET__wfONYna7__"